import type { IToasterInfo } from 'types';

export enum UPLOAD_ERROR {
  fileFormat = 'fileFormat',
  textureFileFormat = 'textureFileFormat',
}

export const toasterInfo: IToasterInfo = {
  error: {
    [UPLOAD_ERROR.fileFormat]: {
      title: 'Format not supported',
      text: 'Some files were not in the right format. Please upload only JPG, JPEG, PNG, HEIC, HEIF for images, and TTF, OTF, WOFF for fonts.',
    },
    [UPLOAD_ERROR.textureFileFormat]: {
      title: 'Format not supported',
      text: 'Not a valid file type. Please update your selection to JPEG, JPG, or PNG.',
    },
  },
};
